import { CardItem } from 'components/pages/Card/model/types';

export const formatCardName = (name: string | undefined, isHTML = true) => {
  if (!name) {
    return isHTML ? { __html: '' } : '';
  }

  // Remove ruby tags, keep base characters, and insert <br /> or ' ' based on isHTML flag
  const formattedName = name
    .replace(/<ruby>(.*?)<rp>.*?<\/rp><rt>.*?<\/rt><rp>.*?<\/rp><\/ruby>/g, '$1')
    .replace(/・/g, isHTML ? '<br />' : '・');

  return isHTML ? { __html: formattedName } : formattedName;
};

export const formatUnlockCardName = (name: string | undefined) => {
  if (!name) {
    return '';
  }

  // Remove text inside <rt> and <rp> tags
  let formattedName = name.replace(/<rt>.*?<\/rt>|<rp>.*?<\/rp>/g, '');

  // Remove ruby and p tags but preserve unique-font spans
  formattedName = formattedName.replace(/<\/?ruby>/g, '');
  formattedName = formattedName.replace(/<\/?p>/g, '');

  // Replace ・ with </span><span>
  formattedName = formattedName.replace(/・/g, '</span><span>');

  formattedName = formattedName.replace(/\\n/g, '');

  // Wrap the entire name in <span> tags
  return `<span>${formattedName}</span>`;
};

export function getClearCardFileName(card: CardItem) {
  if (card.type === 'area') {
    return `${String(card.areaNo).padStart(3, '0')}_clear-card.webp`;
  } else if (card.type === 'mission') {
    return `10${card.missionNo}_mission-clear-card.webp`;
  }
}
